export default __webpack_public_path__ + "static/media/ISEO CLASS 10 SYLLABUS.3326f834.pdf";